module.exports = __webpack_public_path__ + "static/img/cranberry_th.39a0c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/cranberry_th.png
// module id = Z7Wg
// module chunks = 0